<template>
    <div id="app">
        <router-view/>
        <toast ref="toast"></toast>
        <modal ref="modal"></modal>

        <div class="fixed-all" id="fiexd">

            <div class="fixed-1">
                <div v-show="adsUrl" class="main lx">
                    <a id="ads_href2" target="_blank" :href="adsUrl"> <img src="/images/ads.svg" style="height: 100%;"></a>

                    <p></p>
                    <div class="phone">
<!--                        <a  href="#">></a>-->
<!--                        <span class="arrow"></span>-->
                        <span>京东有售，点击购买</span>
                        <span class="arrow"></span>
                    </div>
                </div>

                <div class="main app">
                    <i class="ico ico1"></i>
                    <p>在线客服</p>

                    <div class="ewm" style="padding: 0;width: 250px;height: 250px;right: 100px">
                        <img style="width: 250px;height: 250px" src="/images/storlead_kf.png">
                        <span class="arrow"></span>
                    </div>
                </div>

                <div class="main lx">
                    <i class="ico ico2"></i>
                    <p>联系电话</p>
                    <div class="phone">
                        <i></i>
                        <span>0755-83258725</span>
                        <span class="arrow"></span>
                    </div>
                </div>

            </div>

            <div class="fixed-2" @click="toTop">
                <i class="ico ico3"></i>
                <p>返回顶部</p>
            </div>
        </div>
        <a href="javascript:void(0);" id="download"></a>
    </div>
</template>

<script>
    import '@/utils/filters'
    import Vue from 'vue'
    import Toast from '@/components/Toast'
    import Modal from './components/Modal'
    import api from '@/api'

    export default {
        components: {Toast, Modal},
        data() {
            return {
                url: '',
                adsUrl: ''
            }
        },
        mounted() {
            api.Get('/app/get_jd_ads',{}, res=>{
                this.adsUrl = res.data.dictCodeName
            })
            api.Get('/app/get_android_download_qrcode_url', {}, res => {
                this.url = res.data.url
            })
            Vue.prototype.$toast = this.$refs.toast
            Vue.prototype.$modal = this.$refs.modal

            function IEVersion() {
                let userAgent = navigator.userAgent //取得浏览器的userAgent字符串
                let isIE = userAgent.indexOf("compatible") > -1 && userAgent.indexOf("MSIE") > -1 //判断是否IE<11浏览器
                let isIE11 = userAgent.indexOf('Trident') > -1 && userAgent.indexOf("rv:11.0") > -1
                if (isIE) {
                    let reIE = new RegExp("MSIE (\\d+\\.\\d+);")
                    reIE.test(userAgent)
                    let fIEVersion = parseFloat(RegExp["$1"])
                    if (fIEVersion == 7) {
                        return '7'
                    } else if (fIEVersion == 8) {
                        return '8'
                    } else if (fIEVersion == 9) {
                        return '9'
                    } else if (fIEVersion == 10) {
                        return '10'
                    } else {
                        return '6' //IE版本<=7
                    }
                } else if (isIE11) {
                    return '11' //IE11
                } else {
                    return '-1' //不是ie浏览器
                }
            }

            let explorer = [
                {name: 'IE', minVer: 10},
                {name: 'Edge', minVer: 12},
                {name: 'Opera', minVer: 50},
                {name: 'Firefox', minVer: 55},
                {name: 'Safari', minVer: 9.2},
                {name: 'Chrome', minVer: 40},
                {name: 'QQ', minVer: 9},
                {name: 'Baidu', minVer: 8}
            ]

            function getExploreName() {
                let version = window.navigator.userAgent.toLowerCase(), userAgent = navigator.userAgent
                let noBIDUBrowser = Boolean(userAgent.indexOf("BIDUBrowser") == -1),
                    noQQBrowser = userAgent.indexOf("QQBrowser") == -1
                // Chrome 还要排除一下QQ浏览器和百度浏览器，因为这两也有用Chrome的内核
                let isChrome = userAgent.indexOf("Chrome") > -1 && userAgent.indexOf("Safari") > -1 && noQQBrowser && noBIDUBrowser

                if (IEVersion() > 0) {
                    let ver = IEVersion()
                    return {type: "IE", version: ver}
                } else if (userAgent.indexOf("Edge") > -1) {
                    let ver = version.match(/edge\/([\d.]+)/) ? version.match(/edge\/([\d.]+)/)[1] : "1"
                    return {type: "Edge", version: ver}
                } else if (userAgent.indexOf("Opera") > -1 || userAgent.indexOf("OPR") > -1) {
                    let ver = version.match(/opr\/([\d.]+)/) ? version.match(/opr\/([\d.]+)/)[1] : "1"
                    return {type: "Opera", version: ver}
                } else if (userAgent.indexOf("Firefox") > -1) {
                    let ver = version.match(/firefox\/([\d.]+)/) ? version.match(/firefox\/([\d.]+)/)[1] : "1"
                    return {type: "Firefox", version: ver}
                } else if (userAgent.indexOf("Safari") > -1 && userAgent.indexOf("Chrome") == -1) {
                    let ver = version.match(/safari\/([\d.]+)/) ? version.match(/safari\/([\d.]+)/)[1] : "1"
                    return {type: "Safari", version: ver}
                } else if (isChrome) {
                    let ver = version.match(/chrome\/([\d.]+)/) ? version.match(/chrome\/([\d.]+)/)[1] : "1"
                    return {type: "Chrome", version: ver}
                } else if (userAgent.indexOf("BIDU") >= 0) {
                    let ver = version.match(/bidubrowser\/([\d.]+)/) ? version.match(/bidubrowser\/([\d.]+)/)[1] : '1'
                    return {type: "Baidu", version: ver}
                } else if (userAgent.indexOf("QQ") >= 0) {
                    let ver = version.match(/qqbrowser\/([\d.]+)/) ? version.match(/qqbrowser\/([\d.]+)/)[1] : "1"
                    return {type: "QQ", version: ver}
                } else {
                    return {type: "非主流", version: "1"}
                }
            }

            // console.log(getExploreName())

            function getVerNum() {
                let ver_str = getExploreName().version.split(".")
                return Number(ver_str[0] + (ver_str.length > 1 ? "." + ver_str[1] : ''))
            }

            for (let i = explorer.length - 1; i >= 0; i--) {
                let item = explorer[i]
                let ex = getExploreName()
                let content = ex.type == 'Chrome' ? '您正在使用的浏览器版本过低！请升级！' : '您正在使用' + item.name + '浏览器版本过低！请升级到' + item.minVer + '以上版本！或者使用chrome浏览器！'
                if (item.name == ex.type) {
                    // console.log(getVerNum(), ex)
                    // console.log(item.minVer)
                    // console.log(getVerNum() < item.minVer)
                    if (getVerNum() < item.minVer) {
                        this.$modal.showModal({
                            content: content,
                            okText: '知道了',
                        })
                    }
                }
            }

            window.onscroll = function () {
                let top = document.documentElement.scrollTop || document.body.scrollTop,
                    dom = document.getElementById('fiexd')
                if (top > 150 && !dom.classList.contains('on')) {
                    console.log(">>>>>>>>>>>>>>>>>>>>>>>...come in")
                    dom.classList.add("on")
                } else {
                    dom.classList.remove('on')
                }
            }
        },
        methods: {
            contact() {
                ysf.open()
            },
            toTop() {
                document.body.scrollTop = document.documentElement.scrollTop = 0
            }
        }
    }
</script>

<style lang="scss">
    .fixed-all {
        position: fixed;
        top: 50%;
        transform: translateY(-50%);
        right: 0;
        color: #333;
        width: 80px;
        text-align: center;
        transition: .5s all;
        opacity: 0;
        z-index: -1;

        &.on {
            opacity: 1;
            z-index: 10;
        }
        .arrow {
            display: block;
            width: 0;
            height: 0;
            border-width: 8px 0 8px 8px;
            border-style: solid;
            border-color: transparent transparent transparent #fff;
            position: absolute;
            top: 50%;
            margin-top: -8px;
            right: -8px;
        }

        .phone {
            position: absolute;
            box-shadow: 0 4px 10px 0 rgba(0, 0, 0, 0.3);
            width: 200px;
            right: 100px;
            top: 0;
            background-color: #fff;
            height: 60px;
            line-height: 60px;
            border-radius: 5px;
            display: none;
            i {
                display: inline-block;
                vertical-align: middle;
                width: 14px;
                height: 14px;
                margin-right: 10px;
                background-image: url('./assets/images/suspension_phone_icon_nor.svg');
            }
        }
        .ewm {
            position: absolute;
            //box-shadow: 0 4px 10px 0 rgba(0, 0, 0, 0.3);
            width: 150px;
            height: 160px;
            //background-color: #fff;
            right: 191px;
            border-radius: 5px;
            padding: 20px 10px;
            display: none;
            top: -21px;
            img {
                width: 100px;
                height: 100px;
            }
            p {
                color: #333;
            }
        }
        .app:hover {
            .ewm {
                display: block;
            }
        }

        .fixed-1 {
            border: 1px solid #e0e0e0;
            border-bottom: none;
            border-right: none;

            .main {
                border-bottom: 1px solid #e0e0e0;
                height: 80px;
                padding-top: 10px;
                background-color: #fff;
                cursor: pointer;
                position: relative;

                &:hover {
                    color: #1874ff;
                    border: 1px solid #1874FF;
                    .phone {
                        color: #333;
                    }
                }
            }
        }
        .lx:hover {
            .phone {
                display: block;
            }
        }
        .fixed-2 {
            margin-top: 20px;
            border: 1px solid #e0e0e0;
            height: 80px;
            padding-top: 8px;
            background-color: #fff;
            cursor: pointer;

            &:hover {
                color: #1874ff;

                .ico3 {
                    background-image: url('./assets/images/suspension_top_icon_hov.svg');
                }
            }
        }
        .kf:hover {
            .ico1 {
                background-image: url('./assets/images/suspension_service_icon_hov.svg');
            }
        }
        .lx:hover {
            .ico2 {
                background-image: url('./assets/images/suspension_telephone_icon_hov.svg');
            }
        }
        .app:hover {
            .ico4 {
                background-image: url('./assets/images/sdd_first_qrcode_sel.svg');
            }
        }
        .ico {
            display: block;
            width: 32px;
            height: 32px;
            background-size: 32px 32px;
            margin: 5px auto 0;
        }
        .ico1 {
            background-image: url('./assets/images/suspension_service_icon_nor.svg');
        }
        .ico2 {
            background-image: url('./assets/images/suspension_telephone_icon_nor.svg');
        }
        .ico3 {
            background-image: url('./assets/images/suspension_top_icon_nor.svg');
        }
        .ico4 {
            background-image: url('./assets/images/sdd_first_qrcode_nor.svg');
        }

        p {
            font-size: 12px;
            margin-top: 10px;
        }
    }
    #download {
        position: fixed;
        top: -1000px;
        left: -1000px;
    }
    .disabled-download {
        cursor: not-allowed;
        opacity: .5;
    }
</style>
